import { Component, Input, OnInit, ViewChild, Inject, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { ApsService } from "src/app/services";
import { MatSnackBar } from "@angular/material/snack-bar";
import { StatesService } from "src/app/services";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog"
import { ErrorDialogComponent } from "src/app/components/error-dialog/error-dialog.component";
import { ProcessingDialogComponent } from "src/app/components/processing-dialog/processing-dialog.component";
import { APSMaster, UsState, } from "src/app/models";
import { FormValidationService } from "src/app/services/form-validation.service";

@Component({
  selector: "app-edit-bank-dialog",
  templateUrl: "./edit-bank-dialog.component.html",
  styleUrls: ["./edit-bank-dialog.component.scss"]
})
export class EditBankDialogComponent implements OnInit, OnDestroy
{
  bank: APSMaster;
  newBank: APSMaster;

  public form: FormGroup;
  public states: UsState[] = [];
  public showCustHeader: boolean = false;
  public years: number[] = Array.from({ length: 10 }, (_, i) => (new Date()).getFullYear() + i);

  private statesSubscription: Subscription;

  @Input() public showAddress: boolean = true;
  @Input() public showPrimary: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    private apsService: ApsService,
    private statesService: StatesService,
    public snackBar: MatSnackBar,
    private changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    public dialogRef: MatDialog,
    private formValidationService: FormValidationService,
    @Inject(MAT_DIALOG_DATA) public data: APSMaster,
  )
  {
    this.bank = { ...data };

  }

  public ngOnInit(): void
  {
    this.statesSubscription = this.statesService.states.subscribe(state => this.states = state);

    this.form = this.formBuilder.group({
      NameFirst: [this.data.NameFirst, []],
      NameLast: [this.data.NameLast, []],
      Address1: [this.bank.Address1, [Validators.required]],
      Address2: [this.bank.Address2, []],
      Company: [this.data.CoName, []],
      City: [this.bank.City, [Validators.required]],
      St: [this.bank.St, [Validators.required]],
      Zip: [this.bank.Zip, [Validators.required]],
      BankNo: [this.data.BankNo, []],
      BankType: [this.data.BankType],
      BankAcct: [this.data.BankAcct, []],
      BankName: [this.data.BankName, []],
      RoutingNumber: [this.data.BankNo, []],
      Primary: [this.bank.Primary, []],
      RecNo: [this.data.RecNo],
      SourceNo: [this.data.SourceNo],
      PymtMethod: [this.data.PymtMethod],
      ApplId: [this.data.ApplId],
      Appl: [this.data.Appl],
    });
  }

  public ngOnDestroy(): void
  {
    this.statesSubscription.unsubscribe();
  }

  ngAfterViewChecked()
  {
    this.changeDetectorRef.detectChanges();
  }

  public checkFormValidity(form: AbstractControl): void
  {
    form?.markAllAsTouched();

    if (this.formValidationService.checkFormValidity(form)) 
    {
      this.handleSubmit();
    }
  }

  public async handleSubmit(): Promise<void>
  {
    this.showCustHeader = false;
    const dialogText: string = "Bank"
    const processingDialogRef = this.dialog.open(ProcessingDialogComponent, {
      data: dialogText,
      width: "400px",
      maxWidth: "90%",
      restoreFocus: false,
      disableClose: true,
    });

    const editBank = this.form.dirty ? JSON.parse(JSON.stringify(this.form.value)) : null;
    if (editBank)
    {
      editBank.BranchNo = this.data.BranchNo;
      editBank.RefNo = this.data.RefNo;
      editBank.RefToken = this.data.RefToken;
      editBank.RefProfileId = this.data.RefProfileId;
      const result = await this.apsService.updatePaymentMethod(editBank)
      if (result)
      {
        this.dialog.closeAll();

        this.snackBar.open('✅ Your payment method was edited successfully.', 'Close', {
          duration: 3000,
          panelClass: ['success-snackbar'],
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });

      }
      else
      {
        this.errorDialog("");
      }
    }
    else
    {
      this.dialog.closeAll()
    }
  }

  errorDialog(error): void
  {
    const errorMessage: string = "An error occurred while saving your payment method. \n" + error;

    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      minWidth: "360px",
      data: errorMessage,
    });
    dialogRef.afterClosed().subscribe(_ =>
    {
      this.showCustHeader = true;
    });
  }
}